import { handleActions } from "redux-actions";

import state from "./state";
export type StatState = typeof state;
const stat = handleActions({}, state);

export { stat };
